import React, { FC, useEffect } from 'react';
import { Search as SearchIcon } from '@wix/wix-ui-icons-common';
import { Search as HarmonySearchIcon } from '@wix/wix-ui-icons-common/odeditor';
import { useIsStudio2Ui } from '../../hooks/useIsStudio2Ui';
import { useTranslation } from '@wix/wix-i18n-config';
import s from './Search.scss';
import cs from 'classnames';
import { useNavigate } from 'react-router';
import { CloseButton } from '@wix/design-system';
import { useSearch } from '../../hooks/useSearch';
import { useInternalRoutes } from '../../hooks/useInternalRoutes';

interface SearchProps {
  className?: string;
}

export const Search: FC<SearchProps> = ({ className }) => {
  const { t } = useTranslation();
  const isStudio2Ui = useIsStudio2Ui();
  const navigate = useNavigate();
  const { criteria } = useSearch();
  const [inputValue, setInputValue] = React.useState(criteria);
  const inputRef = React.useRef<HTMLInputElement>(null);
  const { search } = useInternalRoutes();

  const onCloseButtonClick = () => {
    setInputValue('');
    inputRef.current?.focus();
  };

  useEffect(() => {
    setInputValue(criteria);
  }, [criteria]);

  const handleSearch = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const criteria = e.currentTarget.value;
    if (e.key === 'Enter' && criteria !== '') {
      navigate(search.build(criteria));
    }
  };

  return (
    <div className={cs(s.inputContainer, className)}>
      <div className={s.searchIcon}>
        {isStudio2Ui ? (
          <HarmonySearchIcon className={s.searchIcon} />
        ) : (
          <SearchIcon className={s.searchIcon} />
        )}
      </div>
      <input
        value={inputValue}
        ref={inputRef}
        maxLength={100}
        onChange={(e) => setInputValue(e.target.value)}
        className={s.input}
        onKeyUp={handleSearch}
        placeholder={t('app.main.header.input.placeholder')}
      />
      {inputValue && (
        <CloseButton
          size="medium"
          onClick={onCloseButtonClick}
          className={s.clearButton}
        />
      )}
    </div>
  );
};
